









































































































































































import { mapState } from "vuex";

import { Component, Vue, Watch } from "vue-property-decorator";

import { Route } from "vue-router";
import { Tenant } from "@/interfaces/tenants";

import {Content} from "@/interfaces/content";
import { TenantApiClient } from "@/api/tenant_client";
import { displayDate } from "@/date";

@Component({
  computed: {
    ...mapState(["users", "tenants"])
  },
  components: {}
})
export default class TenantUserDetails extends Vue {
  // Mapped from vuex
  tenants!: Tenant[];
  users!: any;
  displayDate = displayDate;

  // Other Variables
  private api = new TenantApiClient();

  public breadcrumbs: any[] = [];
  public isLoading = true;

  public data = {
    user: {} as any,
    original: {} as any,
    tenant: {} as any,
    selectedVideo: null
  };

  public contents = {} as any;
  public otherContents: Content[] = [];
  public isContentLoading = false;

  async mounted() {
    this.setTenant(this.$route.params.tenant_id);
    this.setUser(this.$route.params.user_id);
    this.isContentLoading = true;
    await Promise.all(
      this.data.user.purchases.map((contentId: string) =>
        this.loadVideoDetails(contentId)
      )
    );
    await this.loadAllVideos();
    this.isContentLoading = false;
  }

  async loadVideoDetails(contentId: string) {
    this.contents[contentId] = await this.api.getContent(
      this.data.tenant.tenant_id,
      contentId
    );
  }

  async loadAllVideos() {
    this.otherContents = (
      await this.api.listContent(this.data.tenant.tenant_id)
    ).filter(content => !this.data.user.purchases.includes(content.content_id));
  }

  removeVideo(videoId: string) {
    this.$buefy.dialog.confirm({
      message: "Soll das Video tatsächlich entfernt werden?",
      onConfirm: async () => this.save("purchases", videoId, "remove")
    });
  }

  // Watchers
  @Watch("$route")
  async onRouteChange(newValue: Route) {
    this.setTenant(newValue.params.tenant_id);
    this.setUser(newValue.params.user_id);
    this.isContentLoading = true;
    await Promise.all(
      this.data.user.purchases.map((contentId: string) =>
        this.loadVideoDetails(contentId)
      )
    );
    await this.loadAllVideos();
    this.isContentLoading = false;
  }

  @Watch("data.user.age_verified")
  async onAgeVerifiedChange(newValue: any, oldValue: any) {
    if (oldValue === undefined) return;
    await this.save("age_verified", newValue);
  }

  async addVideo(videoId: string) {
    this.$buefy.dialog.confirm({
      message: "Soll das Video tatsächlich zum User hinzugefügt werden?",
      onConfirm: async () => this.save("purchases", videoId, "add")
    });
    this.data.selectedVideo = null;
  }

  setUser(userId: string) {
    this.data.original = this.users[userId];
    // Make a copy so we don't change the store + know what has been changed
    this.data.user = JSON.parse(JSON.stringify(this.data.original));

    this.$store.commit("pushBreadcrumbs", {
      label: "User Details"
    });
  }

  setTenant(tenantId: string) {
    this.tenants.forEach(tenant => {
      if (tenant.tenant_id === tenantId) {
        this.data.tenant = tenant;

        this.$store.commit("clearBreadcrumbs");
        this.$store.commit("pushBreadcrumbs", {
          to: `/tenant/${tenantId}`,
          label: tenant.name
        });
        this.$store.commit("pushBreadcrumbs", {
          to: `/tenant/${tenantId}/users`,
          label: "Users"
        });
      }
    });
  }

  reset() {
    this.data.user = JSON.parse(JSON.stringify(this.data.original));
  }

  async save(
    field: string,
    new_value: any,
    mode: "replace" | "remove" | "add" = "replace"
  ) {
    try {
      const newUser = await this.api.saveUser(
        this.data.tenant.tenant_id,
        this.data.user.user_id,
        {
          values: new_value,
          field,
          mode
        }
      );
      this.isContentLoading = true;
      await Promise.all(
        newUser.purchases.map(contentId => this.loadVideoDetails(contentId))
      );
      await this.loadAllVideos();
      this.isContentLoading = false;

      this.users[newUser.user_id] = newUser;
      this.data.original = this.users[newUser.user_id];
      this.data.user = JSON.parse(JSON.stringify(this.data.original));

      this.$buefy.toast.open({
        message: "User updated.",
        type: "is-info",
        queue: false
      });
    } catch (e) {
      this.$buefy.toast.open({
        message: "Problem updating user.",
        type: "is-danger",
        queue: false
      });
    }
  }
}
